export default __webpack_public_path__ + "static/media/le_croise12.3f35e267.jpg";